// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  height: 100vh;
  --background: transparent;
}

.eu-council-game-container {
  position: absolute;
  width: 100%;
  top: 0;
  z-index: 1;
  background: transparent;
}

#proposal-game-container-final-vote {
  width: 100% !important;
  height: 100% !important;
  position: relative;
}

.w-h-100 {
  width: 100%;
  height: 100vh;
}

.final-vote-component {
  position: absolute;
  left: 0;
}

.buttons-style {
  display: inline-block;
  position: absolute;
  left: 50rem;
  top: 1.1rem;
  width: 4.2rem;
  height: 4.2rem;
  z-index: 1;
}

.title {
  position: absolute;
  z-index: 1;
  top: 1rem;
  left: 50%;
  transform: translateX(-50%);
  font-size: 1rem;
  color: #ffffff;
  text-align: center;
  text-shadow: 0 4px 0 rgba(0, 0, 0, 0.24);
}

.box2 {
  position: absolute;
  background: white;
  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.16);
  font-size: 1rem;
  color: #003399;
  text-align: center;
  line-height: 1rem;
  border-radius: 1rem;
  height: auto;
  width: 16rem;
  top: 50%;
  left: 50%;
  z-index: 1;
  padding-bottom: 1rem;
  transform: translate(-50%, -50%);
}
.box2 .text {
  font-size: 1rem;
  margin-top: 0.5rem;
  padding: 0.1rem;
  font-weight: 400;
}

.sb10:before {
  content: "";
  width: -15rem;
  height: -15rem;
  position: absolute;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid transparent;
  border-bottom: 10px solid white;
  right: 48%;
  top: -20px;
}

.topic-title {
  font-size: 1.2rem;
}

.text-bold {
  font-size: 1rem;
  margin-top: 0.5rem;
  padding-top: 0.6rem;
  padding: 0.6rem;
  font-weight: bold;
}

.btn-group-light button {
  background-color: transparent;
  border: 2px solid #003399;
  border-radius: 30px;
  color: #003399;
  padding: 0.5rem 1rem;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 0.9rem;
  cursor: pointer;
  margin-top: 0.5rem;
  font-weight: 600;
}

.btn-group .button {
  background-color: #003399;
  border: none;
  color: white;
  padding: 0.7rem 1.5rem;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 0.9rem;
  cursor: pointer;
  margin-top: 0.5rem;
  font-weight: 600;
}

.button-end {
  border-end-end-radius: 3rem;
  border-start-end-radius: 3rem;
}

.button-start {
  border-end-start-radius: 3rem;
  border-start-start-radius: 3rem;
}

.phaserVotingWrapper {
  left: 17rem;
  width: calc(100% - 15rem);
  position: relative;
  top: 0;
}

.box3 {
  position: absolute;
  font-size: 1rem;
  color: #564547;
  text-align: center;
  line-height: 1rem;
  border-radius: 0.667rem;
  min-height: 3rem;
  width: 12.5rem;
  top: 50%;
  left: 50%;
  z-index: 2;
  transform: translate(-50%, -180%);
  background: #CFE7ED linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.16);
}
.box3 .text {
  font-size: 0.667rem;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 1rem;
  padding: 0.4rem;
}

.sb11:before {
  content: "";
  width: -15rem;
  height: -15rem;
  position: absolute;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid transparent;
  border-bottom: 10px solid white;
  right: 48%;
  top: -20px;
}

.box4 {
  position: absolute;
  background: #CFE7ED linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.16);
  font-size: 1rem;
  color: #003399;
  padding-left: 0.2rem;
  padding-right: 0.2rem;
  text-align: center;
  line-height: 1rem;
  border-radius: 0.667rem;
  height: 2rem;
  min-width: 8rem;
  top: 4%;
  left: 50%;
  z-index: 1;
  transform: translate(-50%, -50%);
}
.box4 .text {
  font-size: 1rem;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 1rem;
  padding: 0.5rem;
  white-space: nowrap;
}

.sb12:before {
  content: "";
  width: 0;
  height: 0;
  border-top: 0 solid transparent;
  border-bottom: 1rem solid transparent;
  border-left: 1rem solid #CFE7ED;
  transform: rotate(225deg);
  position: absolute;
  left: 46%;
  top: 73%;
}

.box5 {
  position: absolute;
  padding: 0.675rem;
  font-size: 0.75rem;
  color: #003399;
  text-align: center;
  line-height: 1rem;
  height: 6rem;
  min-width: 16rem;
  top: 50%;
  left: 50%;
  z-index: 1;
  transform: translate(-55%, -41%);
  border-radius: 0.333rem;
  background: #CFE7ED linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.16);
}
.box5 .text {
  font-size: 0.833rem;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 1rem;
  margin-bottom: 0.55rem;
}
.box5 .reject-btn {
  font-size: 0.675rem;
  line-height: 1.167rem;
  min-width: 5.667rem;
  height: 1.463rem;
  min-height: 1.463rem;
  --min-height: 1.463rem;
  --border-color: var(--color-primary-blue);
  --padding-top: 0.25rem;
  --padding-bottom: 0.25rem;
  color: var(--color-primary-blue);
  font-weight: 600;
}
.box5 .approve-btn {
  font-size: 0.675rem;
  line-height: 1.167rem;
  min-width: 5.667rem;
  height: 1.463rem;
  min-height: 1.463rem;
  --min-height: 1.463rem;
  --border-color: var(--color-primary-blue);
  --padding-top: 0.25rem;
  --padding-bottom: 0.25rem;
  --background: var(--color-primary-blue);
  color: white;
  font-weight: 600;
}
.box5 .icons {
  margin-top: 0.2rem;
}
.box5 .icons .flag {
  display: flex;
  align-items: center;
  justify-content: right;
}
.box5 .icons .flag .iconFlag {
  width: 0.817rem;
}
.box5 .icons .star {
  display: flex;
  align-items: center;
  justify-content: left;
}
.box5 .icons .star .iconStar {
  width: 0.852rem;
}
.box5 .icons .text {
  font-size: 0.667rem;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 0.917rem;
  color: var(--color-primary-blue);
  margin-bottom: 0;
  margin-left: 0.2rem;
}
.box5 .icons .red {
  color: var(--color-red_line-red) !important;
}

.graph ::ng-deep svg {
  width: 5.75rem;
  height: 6.917rem;
}
.graph ::ng-deep svg g#bottom-circle {
  transform: translate(0.029rem, var(--y-translate-green-graph));
}
.graph ::ng-deep svg rect#length {
  height: var(--height-green-graph);
}

.graph-white ::ng-deep svg {
  width: 5.75rem;
  height: 6.917rem;
}
.graph-white ::ng-deep svg g#bottom-circle {
  transform: translate(0.029rem, var(--y-translate-white-graph));
}
.graph-white ::ng-deep svg rect#length {
  height: var(--height-white-graph);
}

.sum-number {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -143%);
}

.sum-number-white {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -143%);
}

.dFlex {
  display: flex;
}

.graph-div {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
}
.graph-div .graph-box {
  display: flex;
  flex-direction: column;
  text-align: center;
  position: relative;
}

.modal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 0.333rem;
  background: #CFE7ED linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.16);
  padding: 0.5rem;
  z-index: 2;
  text-align: center;
  width: 20rem;
}
.modal .text {
  color: var(--color-primary-blue);
  font-size: 0.833rem;
  font-weight: 600;
  line-height: 1rem;
  margin-bottom: 0.5rem;
}
.modal .ok-btn {
  font-size: 0.575rem;
  line-height: 1.167rem;
  min-width: 4.667rem;
  height: 1.463rem;
  min-height: 1.463rem;
  --min-height: 1.463rem;
  --border-color: var(--color-primary-blue);
  --padding-top: 0.25rem;
  --padding-bottom: 0.25rem;
  --background: var(--color-primary-blue);
  color: white;
  font-weight: 600;
}

.gameResults-btn {
  position: absolute;
  bottom: 1rem;
  left: 50%;
  z-index: 1;
  min-width: 11rem;
  height: 2.5rem;
  border-radius: 1.333rem;
  cursor: pointer;
  background: var(--color-yellow-bookmark) linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);
  --background: var(--color-yellow-bookmark) linear-gradient(
      0deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.48) 100%
  );
  box-shadow: 0 4px 0 0 rgba(0, 0, 0, 0.16);
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 2rem;
  padding-right: 2rem;
}
.gameResults-btn .btn {
  font-size: 1rem;
  font-weight: 600;
  color: var(--color-primary-blue);
  border-radius: 0.667rem;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/game/presentation-proposal/presentation-proposal.page.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,yBAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,MAAA;EACA,UAAA;EACA,uBAAA;AACF;;AAEA;EACE,sBAAA;EACA,uBAAA;EACA,kBAAA;AACF;;AAUA;EACE,WAAA;EACA,aAAA;AAPF;;AAUA;EACE,kBAAA;EACA,OAAA;AAPF;;AAUA;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;EACA,UAAA;AAPF;;AAUA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,wCAAA;AAPF;;AAUA;EACE,kBAAA;EACA,iBAAA;EACA,yCAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,oBAAA;EACA,gCAAA;AAPF;AASE;EACE,eAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAPJ;;AAWA;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,mCAAA;EACA,oCAAA;EACA,kCAAA;EACA,+BAAA;EACA,UAAA;EACA,UAAA;AARF;;AAWA;EACE,iBAAA;AARF;;AAWA;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AARF;;AAaE;EACE,6BAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAVJ;;AAcA;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAXF;;AAcA;EACE,2BAAA;EACA,6BAAA;AAXF;;AAcA;EACE,6BAAA;EACA,+BAAA;AAXF;;AAcA;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,MAAA;AAXF;;AAcA;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,iCAAA;EACA,kFAAA;EACA,yCAAA;AAXF;AAaE;EACE,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;AAXJ;;AAeA;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,mCAAA;EACA,oCAAA;EACA,kCAAA;EACA,+BAAA;EACA,UAAA;EACA,UAAA;AAZF;;AAeA;EACE,kBAAA;EACA,kFAAA;EACA,yCAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,OAAA;EACA,SAAA;EACA,UAAA;EACA,gCAAA;AAZF;AAcE;EACE,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AAZJ;;AAgBA;EACE,WAAA;EACA,QAAA;EACA,SAAA;EACA,+BAAA;EACA,qCAAA;EACA,+BAAA;EACA,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;AAbF;;AAgBA;EACE,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,gCAAA;EACA,uBAAA;EACA,kFAAA;EACA,yCAAA;AAbF;AAeE;EACE,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;AAbJ;AAgBE;EACE,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,yCAAA;EACA,sBAAA;EACA,yBAAA;EACA,gCAAA;EACA,gBAAA;AAdJ;AAiBE;EACE,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,yCAAA;EACA,sBAAA;EACA,yBAAA;EACA,uCAAA;EACA,YAAA;EACA,gBAAA;AAfJ;AAkBE;EACE,kBAAA;AAhBJ;AAkBI;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;AAhBN;AAkBM;EACE,eAAA;AAhBR;AAoBI;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;AAlBN;AAoBM;EACE,eAAA;AAlBR;AAsBI;EACE,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,gCAAA;EACA,gBAAA;EACA,mBAAA;AApBN;AAuBI;EACE,2CAAA;AArBN;;AA0BA;EACE,cAAA;EACA,gBAAA;AAvBF;AAyBE;EACE,8DAAA;AAvBJ;AA0BE;EACE,iCAAA;AAxBJ;;AA4BA;EACE,cAAA;EACA,gBAAA;AAzBF;AA2BE;EACE,8DAAA;AAzBJ;AA4BE;EACE,iCAAA;AA1BJ;;AA8BA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,iCAAA;AA3BF;;AA8BA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,iCAAA;AA3BF;;AA8BA;EACE,aAAA;AA3BF;;AA8BA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,UAAA;AA3BF;AA6BE;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;AA3BJ;;AA+BA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,uBAAA;EACA,kFAAA;EACA,yCAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;AA5BF;AA8BE;EACE,gCAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AA5BJ;AA+BE;EACE,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,yCAAA;EACA,sBAAA;EACA,yBAAA;EACA,uCAAA;EACA,YAAA;EACA,gBAAA;AA7BJ;;AAiCA;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,eAAA;EACA,yHAAA;EAKA;;;;GAAA;EAKA,yCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAlCF;AAoCE;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,uBAAA;EACA,eAAA;AAlCJ","sourcesContent":["ion-content {\n  height: 100vh;\n  --background: transparent;\n}\n\n.eu-council-game-container {\n  position: absolute;\n  width: 100%;\n  top: 0;\n  z-index: 1;\n  background: transparent;\n}\n\n#proposal-game-container-final-vote {\n  width: 100% !important;\n  height: 100% !important;\n  position: relative;\n}\n\n.container {\n  //position: relative;\n  //top: 0;\n  //left: 1rem;\n  //width: 53rem;\n  //height: 31rem;\n}\n\n.w-h-100 {\n  width: 100%;\n  height: 100vh;\n}\n\n.final-vote-component {\n  position: absolute;\n  left: 0;\n}\n\n.buttons-style {\n  display: inline-block;\n  position: absolute;\n  left: 50rem;\n  top: 1.1rem;\n  width: 4.2rem;\n  height: 4.2rem;\n  z-index: 1;\n}\n\n.title {\n  position: absolute;\n  z-index: 1;\n  top: 1rem;\n  left: 50%;\n  transform: translateX(-50%);\n  font-size: 1rem;\n  color: #ffffff;\n  text-align: center;\n  text-shadow: 0 4px 0 rgba(0, 0, 0, 0.24);\n}\n\n.box2 {\n  position: absolute;\n  background: white;\n  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.16);\n  font-size: 1rem;\n  color: #003399;\n  text-align: center;\n  line-height: 1rem;\n  border-radius: 1rem;\n  height: auto;\n  width: 16rem;\n  top: 50%;\n  left: 50%;\n  z-index: 1;\n  padding-bottom: 1rem;\n  transform: translate(-50%, -50%);\n\n  .text {\n    font-size: 1rem;\n    margin-top: 0.5rem;\n    padding: 0.1rem;\n    font-weight: 400;\n  }\n}\n\n.sb10:before {\n  content: \"\";\n  width: -15rem;\n  height: -15rem;\n  position: absolute;\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid white;\n  right: 48%;\n  top: -20px;\n}\n\n.topic-title {\n  font-size: 1.2rem;\n}\n\n.text-bold {\n  font-size: 1rem;\n  margin-top: 0.5rem;\n  padding-top: 0.6rem;\n  padding: 0.6rem;\n  font-weight: bold;\n}\n\n\n.btn-group-light {\n  button {\n    background-color: transparent;\n    border: 2px solid #003399;\n    border-radius: 30px;\n    color: #003399;\n    padding: 0.5rem 1rem;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    font-size: 0.9rem;\n    cursor: pointer;\n    margin-top: 0.5rem;\n    font-weight: 600;\n  }\n}\n\n.btn-group .button {\n  background-color: #003399;\n  border: none;\n  color: white;\n  padding: 0.7rem 1.5rem;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 0.9rem;\n  cursor: pointer;\n  margin-top: 0.5rem;\n  font-weight: 600;\n}\n\n.button-end {\n  border-end-end-radius: 3rem;\n  border-start-end-radius: 3rem;\n}\n\n.button-start {\n  border-end-start-radius: 3rem;\n  border-start-start-radius: 3rem;\n}\n\n.phaserVotingWrapper {\n  left: 17rem;\n  width: calc(100% - 15rem);\n  position: relative;\n  top: 0;\n}\n\n.box3 {\n  position: absolute;\n  font-size: 1rem;\n  color: #564547;\n  text-align: center;\n  line-height: 1rem;\n  border-radius: 0.667rem;\n  min-height: 3rem;\n  width: 12.5rem;\n  top: 50%;\n  left: 50%;\n  z-index: 2;\n  transform: translate(-50%, -180%);\n  background: #CFE7ED linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);\n  box-shadow: 0 2px 0 0 rgb(0 0 0 / 16%);\n\n  .text {\n    font-size: 0.667rem;\n    font-weight: 600;\n    letter-spacing: 0;\n    line-height: 1rem;\n    padding: 0.4rem;\n  }\n}\n\n.sb11:before {\n  content: \"\";\n  width: -15rem;\n  height: -15rem;\n  position: absolute;\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid white;\n  right: 48%;\n  top: -20px;\n}\n\n.box4 {\n  position: absolute;\n  background: #CFE7ED linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);\n  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.16);\n  font-size: 1rem;\n  color: #003399;\n  padding-left: 0.2rem;\n  padding-right: 0.2rem;\n  text-align: center;\n  line-height: 1rem;\n  border-radius: 0.667rem;\n  height: 2rem;\n  min-width: 8rem;\n  top: 4%;\n  left: 50%;\n  z-index: 1;\n  transform: translate(-50%, -50%);\n\n  .text {\n    font-size: 1rem;\n    font-weight: bold;\n    letter-spacing: 0;\n    line-height: 1rem;\n    padding: 0.5rem;\n    white-space: nowrap;\n  }\n}\n\n.sb12:before {\n  content: \"\";\n  width: 0;\n  height: 0;\n  border-top: 0 solid transparent;\n  border-bottom: 1rem solid transparent;\n  border-left: 1rem solid #CFE7ED;\n  transform: rotate(225deg);\n  position: absolute;\n  left: 46%;\n  top: 73%;\n}\n\n.box5 {\n  position: absolute;\n  padding: 0.675rem;\n  font-size: 0.75rem;\n  color: #003399;\n  text-align: center;\n  line-height: 1rem;\n  height: 6rem;\n  min-width: 16rem;\n  top: 50%;\n  left: 50%;\n  z-index: 1;\n  transform: translate(-55%, -41%);\n  border-radius: 0.333rem;\n  background: #CFE7ED linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);\n  box-shadow: 0 2px 0 0 rgb(0 0 0 / 16%);\n\n  .text {\n    font-size: 0.833rem;\n    font-weight: bold;\n    letter-spacing: 0;\n    line-height: 1rem;\n    margin-bottom: 0.55rem;\n  }\n\n  .reject-btn {\n    font-size: 0.675rem;\n    line-height: 1.167rem;\n    min-width: 5.667rem;\n    height: 1.463rem;\n    min-height: 1.463rem;\n    --min-height: 1.463rem;\n    --border-color: var(--color-primary-blue);\n    --padding-top: 0.25rem;\n    --padding-bottom: 0.25rem;\n    color: var(--color-primary-blue);\n    font-weight: 600;\n  }\n\n  .approve-btn {\n    font-size: 0.675rem;\n    line-height: 1.167rem;\n    min-width: 5.667rem;\n    height: 1.463rem;\n    min-height: 1.463rem;\n    --min-height: 1.463rem;\n    --border-color: var(--color-primary-blue);\n    --padding-top: 0.25rem;\n    --padding-bottom: 0.25rem;\n    --background: var(--color-primary-blue);\n    color: white;\n    font-weight: 600;\n  }\n\n  .icons {\n    margin-top: 0.2rem;\n\n    .flag {\n      display: flex;\n      align-items: center;\n      justify-content: right;\n\n      .iconFlag {\n        width: 0.817rem;\n      }\n    }\n\n    .star {\n      display: flex;\n      align-items: center;\n      justify-content: left;\n\n      .iconStar {\n        width: 0.852rem;\n      }\n    }\n\n    .text {\n      font-size: 0.667rem;\n      font-weight: 600;\n      letter-spacing: 0;\n      line-height: 0.917rem;\n      color: var(--color-primary-blue);\n      margin-bottom: 0;\n      margin-left: 0.2rem;\n    }\n\n    .red {\n      color: var(--color-red_line-red) !important;\n    }\n  }\n}\n\n.graph ::ng-deep svg {\n  width: 5.75rem;\n  height: 6.917rem;\n\n  g#bottom-circle {\n    transform: translate(0.029rem, var(--y-translate-green-graph));\n  }\n\n  rect#length {\n    height: var(--height-green-graph);\n  }\n}\n\n.graph-white ::ng-deep svg {\n  width: 5.75rem;\n  height: 6.917rem;\n\n  g#bottom-circle {\n    transform: translate(0.029rem, var(--y-translate-white-graph));\n  }\n\n  rect#length {\n    height: var(--height-white-graph);\n  }\n}\n\n.sum-number {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -143%);\n}\n\n.sum-number-white {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -143%);\n}\n\n.dFlex {\n  display: flex;\n}\n\n.graph-div {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 2;\n\n  .graph-box {\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n    position: relative;\n  }\n}\n\n.modal {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  border-radius: 0.333rem;\n  background: #CFE7ED linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);\n  box-shadow: 0 2px 0 0 rgb(0 0 0 / 16%);\n  padding: 0.5rem;\n  z-index: 2;\n  text-align: center;\n  width: 20rem;\n\n  .text {\n    color: var(--color-primary-blue);\n    font-size: 0.833rem;\n    font-weight: 600;\n    line-height: 1rem;\n    margin-bottom: 0.5rem;\n  }\n\n  .ok-btn {\n    font-size: 0.575rem;\n    line-height: 1.167rem;\n    min-width: 4.667rem;\n    height: 1.463rem;\n    min-height: 1.463rem;\n    --min-height: 1.463rem;\n    --border-color: var(--color-primary-blue);\n    --padding-top: 0.25rem;\n    --padding-bottom: 0.25rem;\n    --background: var(--color-primary-blue);\n    color: white;\n    font-weight: 600;\n  }\n}\n\n.gameResults-btn {\n  position: absolute;\n  bottom: 1rem;\n  left: 50%;\n  z-index: 1;\n  min-width: 11rem;\n  height: 2.5rem;\n  border-radius: 1.333rem;\n  cursor: pointer;\n  background: var(--color-yellow-bookmark) linear-gradient(\n      0deg,\n      rgba(255, 255, 255, 0) 0%,\n      rgba(255, 255, 255, 0.48) 100%\n  );\n  --background: var(--color-yellow-bookmark) linear-gradient(\n      0deg,\n      rgba(255, 255, 255, 0) 0%,\n      rgba(255, 255, 255, 0.48) 100%\n  );\n  box-shadow: 0 4px 0 0 rgba(0, 0, 0, 0.16);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-left: 2rem;\n  padding-right: 2rem;\n\n  .btn {\n    font-size: 1rem;\n    font-weight: 600;\n    color: var(--color-primary-blue);\n    border-radius: 0.667rem;\n    cursor: pointer;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
